import { rootState } from "../../types/rootState";

export const isPhoneCheck = (state: rootState) =>
  state.auth.addInfo.isPhoneCheck;

export const code = (state: rootState) => state.auth.addInfo.code;

export const userType = (state: rootState) => state.auth.addInfo.userType;